// extracted by mini-css-extract-plugin
export default {"container":"style_container__7UOO5","head":"style_head__2aoGe","label":"style_label__2C9bV"};